import { addStyles, DefaultTheme, rgba } from '../../components/theme';
import { ColorPaletteOrange, ColorPaletteRed } from '../../components/theme.palette';
import { CSS as MenuCSS } from '../../components/menu/menu.style';
import { SubformEditorDropdownCSS } from '../form.designer/editor/subform/form.field.editor.subform.dropdown';

export const CSS = {
	panel: 'c-FormMigrateMapFields',
	search: 'c-FormMigrateMapFields__Search',
	scroll: 'c-FormMigrateMapFields__Scroll',
	columnHeaders: 'c-FormMigrateMapFields__ColumnHeaders',
	columnHeader: 'c-FormMigrateMapFields__ColumnHeader',
	group: 'c-FormMigrateMapFields__Group',
	groupHeader: 'c-FormMigrateMapFields__GroupHeader',
	groupChevron: 'c-FormMigrateMapFields__GroupChevron',
	groupBody: 'c-FormMigrateMapFields__GroupBody',
	row: 'c-FormMigrateMapFields__Row',
	rowLeft: 'c-FormMigrateMapFields__RowLeft',
	fieldInfo: 'c-FormMigrateMapFields__FieldInfo',
	fieldIcon: 'c-FormMigrateMapFields__FieldIcon',
	fieldText: 'c-FormMigrateMapFields__FieldText',
	fieldName: 'c-FormMigrateMapFields__FieldName',
	fieldMeta: 'c-FormMigrateMapFields__FieldMeta',
	targetBox: 'c-FormMigrateMapFields__TargetBox',
	targetBoxEmpty: 'c-FormMigrateMapFields__TargetBox--Empty',
	targetEmptyIcon: 'c-FormMigrateMapFields__TargetEmptyIcon',
	targetIcon: 'c-FormMigrateMapFields__TargetIcon',
	targetLabel: 'c-FormMigrateMapFields__TargetLabel',
	targetLabelText: 'c-FormMigrateMapFields__TargetLabelText',
	targetLabelName: 'c-FormMigrateMapFields__TargetLabelName',
	targetLabelMeta: 'c-FormMigrateMapFields__TargetLabelMeta',
	targetLabelAuto: 'c-FormMigrateMapFields__TargetLabelAuto',
	groupLostBadge: 'c-FormMigrateMapFields__GroupLostBadge',
	groupLostBadgeIcon: 'c-FormMigrateMapFields__GroupLostBadgeIcon',
	dropdownLossBadge: 'c-FormMigrateMapFields__DropdownLossBadge',
	dropdownLossBadgeIcon: 'c-FormMigrateMapFields__DropdownLossBadgeIcon',
	noneItem: 'c-FormMigrateMapFields__NoneItem',
	noneItemHeader: 'c-FormMigrateMapFields__NoneItemHeader',
	noneItemIcon: 'c-FormMigrateMapFields__NoneItemIcon',
	noneItemTitle: 'c-FormMigrateMapFields__NoneItemTitle',
	noneItemSubtitle: 'c-FormMigrateMapFields__NoneItemSubtitle',
};

const ROW_ICON_SIZE = '20px';
const TARGET_BOX_BORDER_WIDTH_PX = 1;
// How far the target box's menu should extend past its button on each side, to align with the box's outer border.
const TARGET_BOX_MENU_INSET_X = `(${TARGET_BOX_BORDER_WIDTH_PX}px + ${DefaultTheme.space(2)})`;
const TARGET_BOX_MENU_INSET_Y = `(${TARGET_BOX_BORDER_WIDTH_PX}px + ${DefaultTheme.space(1)})`;

addStyles({
	[CSS.panel]: {
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '4px',
		background: DefaultTheme.background.lightGrey,
		overflow: 'hidden',
	},
	[CSS.scroll]: {
		height: '320px',
		'overflow-y': 'auto',
		background: DefaultTheme.background.offWhite,
	},
	[CSS.search]: {
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'border-bottom': `1px solid ${DefaultTheme.font.color.divider}`,
		background: DefaultTheme.background.offWhite,
	},
	[CSS.columnHeaders]: {
		display: 'flex',
		'justify-content': 'space-between',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		background: DefaultTheme.background.lightGrey,
	},
	[CSS.columnHeader]: {
		'font-size': '0.7rem',
		'font-weight': 700,
		'letter-spacing': '0.04em',
		'text-transform': 'uppercase',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.group]: {
		'border-top': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.groupHeader]: {
		cursor: 'pointer',
		'list-style': 'none',
		'&::-webkit-details-marker': {
			display: 'none',
		},
		background: DefaultTheme.background.lightGrey,
	},
	[CSS.groupChevron]: {
		transition: 'transform 0.15s ease',
		color: DefaultTheme.font.color.supporting,
	},
	[`${CSS.group}[open] > .${CSS.groupHeader} .${CSS.groupChevron}`]: {
		transform: 'rotate(90deg)',
	},
	[CSS.groupBody]: {
		background: DefaultTheme.background.offWhite,
	},
	[CSS.row]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		gap: DefaultTheme.space(3),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		'border-top': `1px solid ${DefaultTheme.font.color.divider}`,
	},
	[CSS.rowLeft]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(3),
		'min-width': 0,
		flex: 1,
	},
	[`${CSS.scroll} > ${CSS.group}:first-child, ${CSS.scroll} > ${CSS.row}:first-child`]: {
		'border-top': 'none',
	},
	[CSS.fieldInfo]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		'min-width': 0,
	},
	[CSS.fieldIcon]: {
		'font-size': ROW_ICON_SIZE,
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
	},
	[CSS.fieldText]: {
		'min-width': 0,
	},
	[CSS.fieldName]: {
		'font-weight': 700,
		color: DefaultTheme.font.color.primary,
		'white-space': 'nowrap',
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
	},
	[CSS.fieldMeta]: {
		'font-size': '0.8rem',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.targetBox]: {
		border: `${TARGET_BOX_BORDER_WIDTH_PX}px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '4px',
		background: DefaultTheme.background.offWhite,
		width: '260px',
		'flex-shrink': 0,
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		[`& .${SubformEditorDropdownCSS.titleContainer}`]: {
			display: 'none',
		},
		[`& .${SubformEditorDropdownCSS.menuContainer}`]: {
			[`& .${SubformEditorDropdownCSS.button}`]: {
				width: '100%',
				'justify-content': 'space-between',
				padding: 0,
				'font-size': '0.85rem',
				'font-weight': 700,
				'text-transform': 'none',
				color: DefaultTheme.font.color.primary,
				overflow: 'hidden',
				'text-overflow': 'ellipsis',
			},
			[`& .${MenuCSS.menu}`]: {
				left: `calc(-1 * ${TARGET_BOX_MENU_INSET_X})`,
				width: `calc(100% + 2 * ${TARGET_BOX_MENU_INSET_X})`,
				'min-width': `calc(100% + 2 * ${TARGET_BOX_MENU_INSET_X})`,
				top: `calc(100% + ${TARGET_BOX_MENU_INSET_Y})`,
			},
			[`& .${MenuCSS.menu}.${MenuCSS.opensUpward}`]: {
				top: 'auto',
				bottom: `calc(100% + ${TARGET_BOX_MENU_INSET_Y})`,
			},
		},
	},
	[CSS.targetBoxEmpty]: {
		background: rgba(ColorPaletteRed.A700, 0.06),
		'border-color': rgba(ColorPaletteRed.A700, 0.3),
		[`& .${SubformEditorDropdownCSS.button}`]: {
			color: DefaultTheme.font.color.error,
		},
	},
	[CSS.targetEmptyIcon]: {
		'font-size': ROW_ICON_SIZE,
		color: DefaultTheme.font.color.error,
		'flex-shrink': 0,
		'margin-right': DefaultTheme.space(2),
	},
	[CSS.targetIcon]: {
		'font-size': ROW_ICON_SIZE,
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
		'margin-right': DefaultTheme.space(2),
	},
	[CSS.targetLabel]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'space-between',
		gap: DefaultTheme.space(1),
		'min-width': 0,
		flex: 1,
	},
	[CSS.targetLabelText]: {
		'min-width': 0,
		overflow: 'hidden',
		'text-overflow': 'ellipsis',
		'white-space': 'nowrap',
	},
	[CSS.targetLabelName]: {
		'font-weight': 700,
		color: DefaultTheme.font.color.primary,
	},
	[CSS.targetLabelMeta]: {
		'font-weight': 400,
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.targetLabelAuto]: {
		'font-weight': 400,
		color: DefaultTheme.font.color.supporting,
		'flex-shrink': 0,
		'white-space': 'nowrap',
	},
	[CSS.groupLostBadge]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(1),
		'flex-shrink': 0,
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		'border-radius': '999px',
		background: rgba(ColorPaletteRed.A700, 0.06),
		color: DefaultTheme.font.color.error,
		'font-size': '0.8rem',
		'font-weight': 700,
		'white-space': 'nowrap',
	},
	[CSS.groupLostBadgeIcon]: {
		'font-size': '16px',
		'flex-shrink': 0,
	},
	[CSS.dropdownLossBadge]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(1),
		'flex-shrink': 0,
		padding: `${DefaultTheme.space(1)} ${DefaultTheme.space(2)}`,
		'border-radius': '999px',
		background: rgba(ColorPaletteOrange.C900, 0.08),
		color: rgba(ColorPaletteOrange.C900),
		'font-size': '0.8rem',
		'font-weight': 700,
		'white-space': 'nowrap',
	},
	[CSS.dropdownLossBadgeIcon]: {
		'font-size': '16px',
		'flex-shrink': 0,
	},
	[CSS.noneItem]: {
		display: 'flex',
		'flex-direction': 'column',
		width: '100%',
		gap: DefaultTheme.space(1),
	},
	[CSS.noneItemHeader]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		'font-weight': 700,
		color: DefaultTheme.color.accent,
	},
	[CSS.noneItemIcon]: {
		'font-size': ROW_ICON_SIZE,
		'flex-shrink': 0,
	},
	[CSS.noneItemTitle]: {
		'white-space': 'nowrap',
	},
	[CSS.noneItemSubtitle]: {
		'font-size': '0.8rem',
		color: DefaultTheme.font.color.supporting,
	},
});
